import {fetchAndDeserialize} from '../../../util/api-adapter';

import {OmnichannelSsoLinkResponseType, omnichannelSsoResponseSchema} from './chatwoot-type';

export async function fetchChatwootSsoLink(): Promise<OmnichannelSsoLinkResponseType> {
    return fetchAndDeserialize<OmnichannelSsoLinkResponseType>(
        '/cp/chatwoot/get_sso_link',
        omnichannelSsoResponseSchema,
        {
            fetchOptions: {
                skipCache: true,
            },
        }
    );
}
